<template>
<v-app>
    <v-app-bar
        app
        color="#F24653"
        dark
        dense
    >
        <v-toolbar-title>
            <slot name="title">RedChirp Legal Center</slot>
        </v-toolbar-title>
    </v-app-bar>
    <v-main>
        <v-container>
            <div
                style="text-align: center"
            >
                <img 
                    src="@/assets/redchirp-logo-square-center.png" 
                    class="img"
                    style="width: 225px; margin-top: 15px; margin-bottom: 15px;"
                    
                />
            </div>

            <div>
                <v-list-item
                    v-for="(item, index) in documents"
                    :key="index"
                >
                <v-list-item-avatar
                    v-on:click="openDocument(item)"
                    style="cursor: pointer"
                > 
                    <v-icon size="35" style="padding: 0">mdi-file-pdf-box</v-icon>
                </v-list-item-avatar>

                <v-list-item-content
                    v-on:click="openDocument(item)"
                    style="cursor: pointer"
                >
                    <v-list-item-title
                        style="text-decoration: underline; color: blue;"
                    >
                        {{item.label}}
                    </v-list-item-title>
                </v-list-item-content>
                </v-list-item>
            </div>
        </v-container>
    </v-main>
</v-app>
</template>

<script>

export default {
    data() {
        return {
            documents: [
                { 'label' : 'RedChirp Authorized User Agreement v1.1', 'url': 'https://files.redchirp.com/cytcuebxzfwfuvudytawwbbarxaztdcv.pdf' },
                { 'label' : 'RedChirp Platform Privacy Policy v1.1', 'url': 'https://files.redchirp.com/swduwdqyfsvuuwsxzsruaxqfaydxtudt.pdf' },
                { 'label' : 'RedChirp Platform Terms Of Use v1.1', 'url': 'https://files.redchirp.com/errewdxxfxzfuyffywtyfxrcfecrducv.pdf' },
                { 'label' : 'RedChirp Subscription Agreement v1.1', 'url': 'https://files.redchirp.com/zyxeryqxebtrutdrbvwcbwwuxbfwruur.pdf' },
            ],
        }
    },

    methods: {
        openDocument(item) {
            window.open(item.url,'_blank');
        }
    },
}

</script>

<style lang="scss" scoped>
</style>